export const isSafariBrowser = (): boolean => {
  const userAgent = navigator.userAgent.toLowerCase()
  return /safari/i.test(userAgent) && !/chrome|android/i.test(userAgent)
}
